import withController from 'components/common/form-controlled/with-controller.hoc';
import withLabel from 'components/common/form-controlled/with-label.hoc';
import type { TextAreaProps } from 'components/common/input-components/textarea';
import TextArea from 'components/common/input-components/textarea';

export default withLabel(withController<TextAreaProps>(TextArea));
